var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagTrinidadAndTobago(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66318 2.20703C7.2308 2.94634 5.88624 3.91541 4.68549 5.11616C3.48468 6.31697 2.51562 7.66153 1.77637 9.09391L12.0643 20.3657L23.3361 30.6537C24.7686 29.9143 26.1131 28.9453 27.3139 27.7446C28.5147 26.5438 29.4837 25.1992 30.223 23.7668L19.9351 12.495L8.66318 2.20703Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3138 27.745C27.985 27.0738 28.5836 26.3576 29.1106 25.6064L6.82405 3.31982C6.07286 3.84676 5.35667 4.44539 4.68548 5.11657C4.0143 5.78776 3.41567 6.50395 2.88867 7.2552L25.1752 29.5417C25.9264 29.0148 26.6426 28.4162 27.3138 27.745Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68575 27.7449C9.73368 32.7929 17.3147 33.7619 23.3364 30.654L1.77668 9.09424C-1.33113 15.1159 -0.361942 22.697 4.68575 27.7449Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3138 5.11649C22.2658 0.0686145 14.6848 -0.900385 8.66315 2.2073L30.2228 23.7672C33.3307 17.7456 32.3617 10.1644 27.3138 5.11649Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.430664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTrinidadAndTobago);
export default __webpack_public_path__ + "static/media/flag_trinidad_and_tobago.89c5f86fd32145df4dd31bcfb643acca.svg";
export { ForwardRef as ReactComponent };